import { gsap, ScrollTrigger } from 'gsap/all';
import SplitText from "../__vendor/SplitText.min.js";

gsap.registerPlugin(ScrollTrigger);

const projects = () => {
    const projects = document.querySelectorAll('.project');

    projects.forEach((project) => {
        const projectText = project.querySelector('.project-text');

        const text = new SplitText(projectText, { type: "lines" });

        gsap.set(text.lines, {
            opacity: 0,
            y: 30
        });

        const projectTl = gsap.timeline({
            paused: true
        });

        projectTl.set(project.querySelectorAll('.project-img'), {
            className: "+= project-img active",
            stagger: 0.225
        }, 0.15)
        .to(text.lines, {
            y: 0,
            opacity: 1,
            stagger: 0.125
        }, 0.75);

        ScrollTrigger.create({
            scroller:'[data-scroll-container]',
            trigger: project,
            start: 'top bottom',
            end: 'bottom top',
            animation: projectTl,
            toggleActions: 'play none none none',
        });
    });
};

export default projects;
